import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { Redirect } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import { Button, CardActions, AppBar, Tabs, Tab, Icon } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import { childrenRef, eventsRef, contactsRef } from '../../firebase';

import { toast } from 'react-toastify';
import moment from 'moment';

const styles = theme => ({
    title: {
        paddingLeft: '80px',
        paddingRight: '80px',
        paddingTop: '35px',
    },
    card: {
        marginTop: "10px",
        width: "100%",
        margin: "25px 0",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.14)",
        borderRadius: "3px",
        color: "rgba(0, 0, 0, 0.87)",
        background: "#fff"
    },
    cardHover: {
        marginTop: "30px",
        width: "100%",
        margin: "25px 0",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.14)",
        borderRadius: "3px",
        color: "rgba(0, 0, 0, 0.87)",
        background: "#AAA"
    },
    cardAvatar: {
        maxWidth: "130px",
        maxHeight: "130px",
        borderRadius: "50%",
        overflow: "hidden",
        boxShadow:
            "0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
    },

    textAlign: {
        textAlign: "center"
    },
    cardSubtitle: {
        color: "#999",
        fontSize: "1em",
        textTransform: "uppercase",
        marginTop: "10px",
        marginBottom: "10px"
    },
    cardTitle: {
        fontSize: "1.3em",
        marginTop: "10px",
        marginBottom: "10px"
    },
    cardDescription: {
        padding: "5px 10px",
    },
    cardActions: {
        height: "auto",
        display: "inline"
    }
});

class ContactDetails extends Component {
    constructor(props) {
        super(props);
        const { id } = props.match.params;
        this.state = {
            loading: true,
            open: false,
            deleteStatus: false,
            deleteError: false,
            redirect: false,
            updateRequest: false,
            bgColor: '#FFF',
            id,
            firstName: '',
            lastName: '',
            kids: [],
            events: [],
        };
    }

    componentDidMount() {
        const { id } = this.props.match.params;
        let promises = []

        contactsRef.doc(id).get()
            .then(snapshot => {
                const { userId, firstName, lastName } = snapshot.data()

                console.log(userId)

                if(userId !== '' && userId !== undefined) {
                    promises.push(childrenRef.where('parentId', '==', userId).get())
                    promises.push(eventsRef.where('refId', '==', userId).get())
            
                    Promise.all(promises)
                        .then(res => {
                            console.log(res[0].size)
            
                            let kids = []
                            res[0].forEach(doc => {
                                kids.push(doc.data().firstName + ' ' + doc.data().lastName)
                            })
            
                            let events = []
                            res[1].forEach(doc => {
                                events.push({
                                    name: doc.data().name,
                                    date: doc.data().date,
                                })
                            })
            
                            console.log(kids)
            
                            this.setState({
                                loading: false,
                                kids,
                                events,
                                firstName,
                                lastName,
                            })
                        })
                    } else {
                        this.setState({
                            loading: false,
                            kids: [],
                            events: [],
                            firstName: firstName,
                            lastName: lastName,
                        })
                    }
            })
        
    }

    handleChange = (event, value) => {
        this.setState({ value });
    };


    eventDetail = (id) => {
        this.setState({
            eventUrl: '/events/update/' + id,
            eventRedirect: true,
        })
    }

    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    deleteContact = () => {
        this.setState({ open: false });
        const { id } = this.props.match.params;
        contactsRef.doc(id).delete()
            .then(() => {
                /* Push.create("KBAAZ", {
                    body: "Contact deleted successfully!!!",
                    logo: './k-logo.png',
                    timeout: 4000,
                    onClick: function () {
                        window.focus();
                        this.close();
                    }
                }); */
                toast.success('Contact deleted successfully!', {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
                this.setState({
                    redirect: true,
                });
            })
            .catch(() => {
                /* Push.create("KBAAZ", {
                    body: "Some error occurred!!!",
                    logo: './k-logo.png',
                    timeout: 4000,
                    onClick: function () {
                        window.focus();
                        this.close();
                    }
                }); */
                toast.error('Some error occurred!', {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            });
    }

    render() {
        const { classes } = this.props;

        if (this.state.redirect) {
            return(
                <Redirect to='/contacts/'/>
            )
        }
        
        if (this.state.loading) {
            return (
                <h2>Loading...</h2>
            );
        }
        
        if (this.state.updateRequest) {
            var updateId = "/contacts/update/" + this.state.id;
            return (
                <Redirect to={updateId} />
            );
        }

        const { firstName, lastName, events, kids } = this.state

        let kidSection = []

        kids.forEach((kid, index) => kidSection[index] = <div style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
            <img src="https://firebasestorage.googleapis.com/v0/b/fir-kbaaz.appspot.com/o/avatars%2Fuser.png?alt=media&token=692478e2-252e-4503-8b8b-5553f5b58556" alt="..." style={{ height: '30px' }} />
            <Typography variant='title' className={classes.cardDescription}>
                {kid}
            </Typography>
        </div>)

        let eventSection = []

        events.forEach((event, index) => {
            eventSection[index] = <Grid style={{ margin:'10px' }} container item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid item xs={12} sm={6} md={9} lg={9} xl={9}>
                    {event.name}
                </Grid>
                <Grid item xs={12} sm={6} md={1} lg={1} xl={1}>
                    {moment(event.date, 'MM/DD/YYYY').isValid() ? event.date : moment(event.date, 'DD/MM/YYYY').format('MM/DD/YYYY')}
                </Grid>
            </Grid>
        })

        return (
                <Card className={classes.card}>
                    <CardContent className={classes.CardContent}>
                        <Grid spacing={24} container xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Grid alignContent='center' item xs={12} sm={3} md={2} lg={2} xl={2}>
                                <div style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <img src="https://firebasestorage.googleapis.com/v0/b/fir-kbaaz.appspot.com/o/avatars%2Fuser.png?alt=media&token=692478e2-252e-4503-8b8b-5553f5b58556" alt="..." style={{ height: '80px' }} />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6} md={10} lg={8} xl={8}>
                                <Typography variant='title' className={classes.cardDescription}>
                                {firstName + ' ' + lastName}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={3} md={2} lg={2} xl={2}>
                                <Button onClick={() =>{ this.setState({ updateRequest: true }) }} variant="fab" color="secondary" aria-label="edit" className={classes.button}>
                                    <Icon>edit_icon</Icon>
                                </Button>
                            </Grid>
                            <Grid alignContent='center' item xs={12} sm={3} md={2} lg={2} xl={2}>
                                <Typography variant='title' className={classes.cardDescription}>
                                    Kids
                                </Typography>
                            </Grid>
                            <Grid style={{ display: 'flex', flexDirection: 'row' }} item xs={12} sm={9} md={10} lg={10} xl={10}>
                                {kidSection}
                            </Grid>
                            <Grid alignContent='center' item xs={12} sm={3} md={2} lg={2} xl={2}>
                                <Typography variant='title' className={classes.cardDescription}>
                                    Events
                                </Typography>
                            </Grid>
                            <Grid container item xs={12} sm={9} md={10} lg={10} xl={10}>
                                {eventSection}
                            </Grid>
                        </Grid>
                    </CardContent>
                <CardActions className={classes.textAlign + " " + classes.cardActions}>
                    <Button onClick={this.handleClickOpen} variant="raised" color="primary">DELETE</Button>
                </CardActions>
                <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Alert!!!"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Are you sure you want to delete? This is action is irreversible
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.deleteContact} color="primary">
                            Yes
                        </Button>
                        <Button onClick={this.handleClose} color="primary" autoFocus>
                            No
                        </Button>
                    </DialogActions>
                </Dialog>
                </Card >
        );
    }
}

ContactDetails.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ContactDetails);



// WEBPACK FOOTER //
// ./src/components/Contacts/ContactDetails.js